import React from 'react';
import CreateOrder from '../../components/create-order';

const CreateOrderPage: React.FC = () => {
  return <CreateOrder />;
};

export default CreateOrderPage;
